<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Propira Terms & Conditions</h1>
        </div>
    </div>
</div>

<div class="col-md-12 breaeea">

    <ul class="breadcrumb">
        <li><a routerLink="/">Home</a></li>
         <li>Term Condition</li>
    </ul>

</div>

<div class="container-fluid paddEqual">
    <div class="container">
        <app-matloader *ngIf="loader"></app-matloader>
        <div class="row">
            <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12">
                <div class="tg-promobox">
                    <span [innerHtml]="data"></span>
                </div>
            </div>
        </div>
    </div>
</div>